import { gql } from "@apollo/client";

export const ATTRACTION = gql`
  query Attraction($culture: String!, $first: Int!, $skip: Int!) {
    attraction(where: {localization: {culture: $culture}}, first: $first, skip: $skip) {
      localization {
        localizationSet
      }
      forecaWeatherId
      displayText
      cover {
        paths
      }
      location {
        latitude
        longitude
      }
    }
  }
`

export const ATTRACTION_DETAILS = gql`
  query AttractionDetails($localizationSet: String!, $culture: String!) {
    attraction(where: {localization: {culture: $culture, localizationSet: $localizationSet}}) {
      __typename
      contentItemId
      localization {
        localizationSet
      }
      forecaWeatherId
      displayText
      bestVisitingSeason
      estimatedVisitDuration
      mostVisitingHours
      groundArea
      cover {
        paths
      }
      location {
        latitude
        longitude
      }
      city {
        contentItems {
          __typename
          ... on City {
            name
            borderCoordinates
            contentItemId
            country {
              contentItems {
                __typename
                ... on Country {
                  name
                  borderCoordinates
                }
              }
            }
          }
        }
      }
      content {
        contentItems {
          contentItemId
          contentType
        }
      }
    }
  }
`